export { AtnDsTextAreaComponent as Component } from './text-area.component'
